module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Translations', [_c('Theme', [_c('v-style', [_vm._v("body {overflow: hidden; }")]), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.isCguModalVisible) ? _c('CguModal') : _vm._e(), _vm._v(" "), _c('Edits', {
    attrs: {
      "datas": _vm.datas
    },
    on: {
      "rename-favorite": function (builder) { return _vm.$emit('rename-favorite', builder); }
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1022f76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/plano-scaffold.vue
// module id = 3332
// module chunks = 0